import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../views/Home.vue'
import business from '../views/business.vue'
import bussvideo from '../views/bussvideo.vue'
import shortvideo from '../views/shortvideo.vue'
import shootvideo from '../views/shootvideo.vue'
import videocourse from '../views/videocourse.vue'
import multimedia from '../views/multimedia.vue'
import casepage from '../views/casepage.vue'
import aboutus from '../views/aboutus.vue'


const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err=>err)
}

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'home',
    component: home
  },
  {
    path: '/business',
    name: 'business',
    component: business
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/Bussiness.vue')
  },
  {
    path: '/bussvideo',
    name: 'bussvideo',
    component: bussvideo
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/Bussiness.vue')
  },
  {
    path: '/shortvideo',
    name: 'shortvideo',
    component: shortvideo
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/Bussiness.vue')
  },
  {
    path: '/shootvideo',
    name: 'shootvideo',
    component: shootvideo
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/Bussiness.vue')
  },
  {
    path: '/videocourse',
    name: 'videocourse',
    component: videocourse
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/Bussiness.vue')
  },
  {
    path: '/multimedia',
    name: 'multimedia',
    component: multimedia
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/Bussiness.vue')
  },
  {
    path: '/casepage',
    name: 'casepage',
    component: casepage
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/Bussiness.vue')
  },
  {
    path: '/aboutus',
    name: 'aboutus',
    component: aboutus
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/Bussiness.vue')
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 期望滚动到哪个位置
    return {
      x: 0,
      y: 0
    }
  },
})

export default router
